export type ReportGraphType = 'daily-performance' | 'weekly-performance' | 'monthly-performance';

/** The range picks the grouping, so no chart outgrows ~31 points. */
export function reportGraphType(days: number): ReportGraphType {
    if (days <= 31) {
        return 'daily-performance';
    }

    return days <= 183 ? 'weekly-performance' : 'monthly-performance';
}
